// Naming convention: Present tense verbs, all lowercase. Does not include ">" character.
export default {
  success: 'success',
  start: 'start',
  stop: 'stop',
  canceledStop: 'canceledStop',
  failure: 'failure',
  initializing: 'initializing',
  exiting: 'exiting',
  timeout: 'timeout',
  institutionSelected: 'institution selected',
  addInstitutionManually: 'add institution manually',
  addAccountsManually: 'add accounts manually',
  impression: 'impression',
  select: 'select',
  dismiss: 'dismiss',
  feedback: 'feedback',
  goBack: 'go back',
  submitStep: 'submit step',
  clickLink: 'click link',
  clickedCTA: 'clicked cta',
  submitForm: 'submit form',
  actionItemCTA: 'action item cta',
  bannerCTA: 'banner cta',
  navBarItem: 'nav bar item',
  roadPlanItem: 'road plan item',
  uploadingNmars: 'uploading nmars',
  uploadNmars: 'upload nmars',
  welcomeScreen: 'welcome screen',
  fieldFocused: 'field focused',
  fieldBlurred: 'field blurred',
};
